import { useTranslation } from 'react-i18next';
import { IntegrationContainer } from '../components/IntegrationContainer';
import { Step } from '../components/Step';
import { Step1 } from './components/Step1';
import { Step2 } from './components/Step2';
import { Step3 } from './components/Step3';
import { Step4 } from './components/Step4';
import { useCastillaConnection } from './hooks';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import { guideUrl } from './consts';

export const Castilla = () => {
  const { handleSelectedCompanyChange, selectedCompany, triggerConnection, isConnected, isConnectBtnDisabled } =
    useCastillaConnection();
  const { t } = useTranslation('settings');

  return (
    <IntegrationContainer setSelectedCompany={handleSelectedCompanyChange} guideUrl={guideUrl}>
      {selectedCompany && (
        <>
          <Step1 />
          <Step2 triggerConnection={triggerConnection} isConnectBtnDisabled={isConnectBtnDisabled} />
          {isConnected && (
            <>
              <Step3 />
              <Step4 />
              <Step
                title={`${t('integrations.step')} 5`}
                subtitle={t('integrations.factorial.review the data in the view edit employees section')}
                Icon={HowToRegIcon}
              />
            </>
          )}
        </>
      )}
    </IntegrationContainer>
  );
};
